export default {"src":"/_next/static/media/Torino.131f57b9.svg","height":600,"width":500,"blurWidth":0,"blurHeight":0};